// ============================================================================
// consoleControl.js — DEBE importarse el primero en index.js.
// En producción silencia console.log / info / debug (el ruido de depuración que
// se acumuló por toda la app) y deja SOLO lo imprescindible: console.warn y
// console.error (errores reales). En desarrollo no toca nada.
// Siempre imprime UNA línea con la versión del bundle cargado, como punto de
// referencia para saber qué rama/commit está sirviéndose.
// ============================================================================
import { BUILD_INFO, BUILD_LABEL } from './buildInfo';

// Referencia nativa antes de sobreescribir, para que el banner se vea siempre.
const nativeLog = console.log.bind(console);

if (process.env.NODE_ENV === 'production') {
  const noop = () => {};
  console.log = noop;
  console.info = noop;
  console.debug = noop;
  // console.warn y console.error se conservan intactos (imprescindibles).
}

// Banner de versión (siempre visible, incluso con los logs silenciados).
nativeLog(
  `%c Task Manager %c ${BUILD_LABEL} `,
  'background:#00d4aa;color:#04231d;font-weight:700;border-radius:3px 0 0 3px;padding:2px 6px',
  `background:#04231d;color:#8affe4;border-radius:0 3px 3px 0;padding:2px 6px`,
);
if (BUILD_INFO.env !== 'production') {
  nativeLog('[build] modo desarrollo — logs de consola activos');
}
